import React from 'react';
import '../style.css'
import styles from '../index.module.css'
import wavesBottom from '../../../../assets/journaler/solutions/waves_bot.png'

const Header = ({ content }) => (
  <div>
    <div className='position-relative w-100' style={{ overflow: 'hidden' }}>
      <div className='container'>
        <div className={styles.headerContent}>

          {/* Main Headline */}
          <div className={styles.mainHeadline}>
            {content.title} <span className={styles.gradientText}>{content.gradient}</span>
          </div>

          {/* Description */}
          <div className={styles.description}>
            {content.des}
          </div>

          <img src={wavesBottom} className={styles.wavesBottom} alt='waves bottom' />

        </div>
      </div>

      <div className='container'>
        <div className={styles.blurContainer}>
          {/* Category Label */}
          <div className={styles.categoryLabel}>
            {content.subtitle?.toUpperCase()}
          </div>
          <div className={styles.subtitle2}>{content.subtitle2}</div>
          <div className={styles.subDes}>{content.subDes}</div>
          {/* CTA Button */}
          <div className={styles.buttonContainer}>
            <a
              className={styles.ctaButton}
              href='https://calendar.app.google/pyyseHYSTzx3Xo9n8'
              rel='noreferrer'
              target='_blank'
            >
              {content.btn}
            </a>
          </div>
        </div>
      </div>
    </div>

  </div>
)

export default Header